import {
  getStatus,
  getIconType,
  getImportance,
  getSolvability,
} from '../../constants/seoMappings';

const plural = (n, word) => `${n} ${word}${n === 1 ? '' : 's'}`;

const diffInDays = (fromMs, toMs) => {
  const diffMs = toMs - fromMs;
  return Math.floor(diffMs / (1000 * 60 * 60 * 24));
};

const diffInMonthsApprox = (fromMs, toMs) => {
  const diffMs = toMs - fromMs;
  return Math.floor(diffMs / (1000 * 60 * 60 * 24 * 30.44)); // avg month
};

const diffInYearsApprox = (fromMs, toMs) => {
  const diffMs = toMs - fromMs;
  return Math.floor(diffMs / (1000 * 60 * 60 * 24 * 365.25)); // avg year
};

/**
 * Transforms the domain_registration criteria from WooRank API response.
 * Legacy copy expects "created/expires" strings, or a not-found message.
 *
 * @param {Object} domainRegistrationCriteria - criteria.domain_registration
 * @returns {Object} transformed criteria
 */
export const transformDomainRegistration = (domainRegistrationCriteria) => {
  // Missing criteria: show legacy not-found copy
  if (!domainRegistrationCriteria) {
    return {
      status: 'error',
      iconType: 'error',
      importance: { level: 0, text: '' },
      solvability: { level: 0, text: '' },
      isEmpty: true,
      message: 'The info related to the Domain Registration was not found.',
      data: null,
    };
  }

  const wooRankStatus = domainRegistrationCriteria?.status || 'neutral';
  const importance = domainRegistrationCriteria?.importance || 0;
  const solvability = domainRegistrationCriteria?.solvability || 0;

  const creationMs = Number(domainRegistrationCriteria?.data?.creation?.date || 0);
  const expirationMs = Number(domainRegistrationCriteria?.data?.expiration?.date || 0);

  const hasCreation = creationMs > 0;
  const hasExpiration = expirationMs > 0;
  const isEmpty = !(hasCreation && hasExpiration);

  if (isEmpty) {
    return {
      status: 'error',
      iconType: 'error',
      importance: getImportance(importance),
      solvability: getSolvability(solvability),
      isEmpty: true,
      message: 'The info related to the Domain Registration was not found.',
      data: null,
    };
  }

  const now = Date.now();
  const yearsOld = Math.max(0, diffInYearsApprox(creationMs, now));
  const monthsUntilExpiry = diffInMonthsApprox(now, expirationMs);
  const daysUntilExpiry = diffInDays(now, expirationMs);

  const createdText = `Created ${plural(yearsOld, 'year')} ago`;

  let expiresText = 'Expiration date unavailable';
  if (daysUntilExpiry < 0) {
    expiresText = 'Expired';
  } else if (monthsUntilExpiry >= 1) {
    expiresText = `Expires in ${plural(monthsUntilExpiry, 'month')}`;
  } else {
    expiresText = `Expires in ${plural(Math.max(0, daysUntilExpiry), 'day')}`;
  }

  return {
    status: getStatus(wooRankStatus),
    iconType: getIconType(wooRankStatus),
    importance: getImportance(importance),
    solvability: getSolvability(solvability),
    isEmpty: false,
    message: null,
    data: {
      createdText,
      expiresText,
      creationMs,
      expirationMs,
    },
  };
};

export default transformDomainRegistration;


